import { resolvePath } from '@loaders.gl/loader-utils';
import { makeResponse } from "../utils/response-utils.js";
export function isNodePath(url) {
  return !isRequestURL(url) && !isDataURL(url);
}
export function isRequestURL(url) {
  return url.startsWith('http:') || url.startsWith('https:');
}
export function isDataURL(url) {
  return url.startsWith('data:');
}
export async function fetchFile(urlOrData, fetchOptions) {
  if (typeof urlOrData === 'string') {
    const url = resolvePath(urlOrData);
    if (isNodePath(url)) {
      var _globalThis$loaders;
      if ((_globalThis$loaders = globalThis.loaders) !== null && _globalThis$loaders !== void 0 && _globalThis$loaders.fetchNode) {
        var _globalThis$loaders2;
        return (_globalThis$loaders2 = globalThis.loaders) === null || _globalThis$loaders2 === void 0 ? void 0 : _globalThis$loaders2.fetchNode(url, fetchOptions);
      }
    }
    return await fetch(url, fetchOptions);
  }
  return await makeResponse(urlOrData);
}
//# sourceMappingURL=fetch-file.js.map